import { AuthTokens } from '../types';
import { apiCall } from '../utils/apiInterceptor';

/**
 * Base authenticated API service that handles token management
 */
export class AuthenticatedApiService {
  private tokens: AuthTokens | null = null;
  private onTokenRefresh: (tokens: AuthTokens) => void = () => {};

  constructor() {
    // Load tokens from localStorage on initialization
    this.loadTokensFromStorage();
  }

  /**
   * Set the current tokens and refresh callback
   */
  setTokens(tokens: AuthTokens | null, onTokenRefresh: (tokens: AuthTokens) => void) {
    this.tokens = tokens;
    this.onTokenRefresh = onTokenRefresh;
  }

  /**
   * Load tokens from localStorage
   */
  private loadTokensFromStorage() {
    try {
      const storedTokens = localStorage.getItem('authTokens');
      if (storedTokens) {
        this.tokens = JSON.parse(storedTokens);
      }
    } catch (error) {
      console.error('Error loading tokens from storage:', error);
      this.tokens = null;
    }
  }

  /**
   * Make an authenticated API call
   */
  protected async makeAuthenticatedCall(
    url: string,
    options: RequestInit = {}
  ): Promise<Response> {
    if (!this.tokens) {
      throw new Error('No authentication tokens available');
    }

    return await apiCall(
      url,
      options,
      this.tokens,
      this.onTokenRefresh
    );
  }

  /**
   * Get current tokens
   */
  getTokens(): AuthTokens | null {
    return this.tokens;
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated(): boolean {
    return this.tokens !== null && this.tokens.accessToken !== '';
  }
}
